export enum MenuType {
    Day = 0,
    Week = 1,
    Undefined = 2
}
